import React, { useContext } from 'react';

import { Row, Col, AutoComplete } from 'antd';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import { FormInput } from '@components/Gui/NwForm/FormInputs';
import { NwFakeFormItem } from '@components/Gui/NwForm/NwFakeFormWrapper';
import SelectCountry from '@components/Gui/NwForm/SelectCountry';

const Container = styled.div`
    width: 100%;

    .ant-input-prefix {
        margin: auto 12px auto 0;
    }

    .ant-input-prefix,
    .select-wrapper > .prefix {
        color: ${(props) => props.theme.PrimaryDarkLight} !important;
        font-size: 0.75rem !important;
        height: 1rem;
        border-right: 1px solid ${(props) => props.theme.DarkerBorderColor};
        padding-right: 0.4rem;
        display: flex;
        justify-content: center;
        text-transform: uppercase;
    }

    & > .ant-row {
        margin-bottom: 0.75rem;
    }

    .select-wrapper {
        position: relative;
        width: 100%;
        .prefix {
            position: absolute;
            z-index: 1;
            padding-left: 0.7rem;
            top: 0.4rem;
        }
        .ant-select {
            width: 100%;
        }

        &.select-wrapper-city {
            .ant-select-selection-search {
                padding-left: 3rem;
            }
        }
        &.select-wrapper-country {
            .ant-select {
                width: calc(100% - 1.9rem);
            }

            .ant-select-selector {
                padding-left: 6rem !important;
            }
        }
    }
`;

const AddressForm = ({ value, onChange, onBlur, useAddressName, fieldErrors }) => {
    const { cachedList } = useContext(ListContext);
    const cities = cachedList.cities.items.map((city) => city.Name);

    const handleInputChange = (event) => {
        onChange({
            ...value,
            [event.target.name]: event.target.value,
        });
    };

    const handleCityChange = (city) => {
        onChange({
            ...value,
            City: city,
        });
    };

    const handleCountryChange = (country) => {
        onChange({
            ...value,
            Country: country,
        });
    };

    // ogni campo mostra il proprio errore: il riquadro esterno resta neutro.
    // il bordo rosso lo disegnano gli input di antd leggendo la propria prop `status`,
    // non le classi del contenitore, quindi va passata a ciascun controllo
    const fieldError = (name) => (fieldErrors ? fieldErrors[name] : undefined);
    const fieldStatus = (name) => (fieldError(name) ? 'error' : undefined);

    const renderField = (name, control) => <NwFakeFormItem rowsGap="0" error={fieldError(name)} control={control} />;

    return (
        <Container>
            {useAddressName && (
                <Row gutter={16}>
                    <Col span={24}>
                        {renderField(
                            'Name',
                            <FormInput
                                prefix="C/O"
                                value={value.Name}
                                name="Name"
                                status={fieldStatus('Name')}
                                onChange={handleInputChange}
                            />
                        )}
                    </Col>
                </Row>
            )}
            <Row gutter={16}>
                <Col span={24}>
                    {renderField(
                        'Street',
                        <FormInput
                            prefix="STREET"
                            value={value.Street}
                            name="Street"
                            status={fieldStatus('Street')}
                            onChange={handleInputChange}
                        />
                    )}
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={16}>
                    {renderField(
                        'City',
                        <div className="select-wrapper select-wrapper-city">
                            <div className="prefix">CITY</div>
                            <AutoComplete
                                autoComplete="off"
                                value={value.City}
                                dataSource={cities}
                                status={fieldStatus('City')}
                                onChange={handleCityChange}
                                onBlur={onBlur}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                filterOption={(inputValue, option) =>
                                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                            />
                        </div>
                    )}
                </Col>
                <Col span={8}>
                    {renderField(
                        'Zip',
                        <FormInput
                            prefix="ZIP"
                            value={value.Zip}
                            name="Zip"
                            status={fieldStatus('Zip')}
                            onChange={handleInputChange}
                            onBlur={onBlur}
                        />
                    )}
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    {renderField(
                        'County',
                        <FormInput
                            prefix="COUNTY / PROV"
                            value={value.County}
                            name="County"
                            status={fieldStatus('County')}
                            onChange={handleInputChange}
                            onBlur={onBlur}
                        />
                    )}
                </Col>
                <Col span={12}>
                    {renderField(
                        'State',
                        <FormInput
                            prefix="STATE / REGION"
                            value={value.State}
                            name="State"
                            status={fieldStatus('State')}
                            onChange={handleInputChange}
                            onBlur={onBlur}
                        />
                    )}
                </Col>
            </Row>
            <Row gutter={16} align="middle">
                <Col span={24}>
                    {renderField(
                        'Country',
                        <div className="select-wrapper select-wrapper-country">
                            <div className="prefix">COUNTRY</div>
                            <SelectCountry
                                name="Country"
                                value={value.Country}
                                status={fieldStatus('Country')}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                onChange={handleCountryChange}
                                onBlur={onBlur}
                            />
                        </div>
                    )}
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    {renderField(
                        'Access',
                        <FormInput
                            prefix="ACCESS"
                            value={value.Access}
                            name="Access"
                            status={fieldStatus('Access')}
                            onChange={handleInputChange}
                            onBlur={onBlur}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default AddressForm;
